module.exports = __webpack_public_path__ + "img/m1-screenshot-11.bb3becf6.png";